import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DigitalEquipment, Purview, Roadwork, RoadworkSection, User } from "src/app/models";

import { RoadworkSegmentAssignment } from "../models/roadwork-segment-assignment.model";
import { DigitalRoadworkDto, RoadDto } from "./bbo-client.service";
import { DigitalRoadworkDataFacade } from "./digital-roadwork-data.facade";


/**
 * The DigitalRoadworkMockDataService manages mock data calls.
 */
@Injectable()
export class DigitalRoadworkMockDataService implements DigitalRoadworkDataFacade {

	constructor(
		private readonly httpClient: HttpClient,
		// private jwtHelper: JwtHelperService,
	) {}
	refreshToken(): Observable<User> {
		throw new Error("Method not implemented.");
	}
	postLogin(username: string, password: string): Observable<User> {
		throw new Error("Method not implemented." + username + password);
	}
	postDigitalRoadworkDisallowAutomaticCloseForLongTermRoadwork(roadworkId: string): Observable<unknown> {
		throw new Error("Method not implemented." + roadworkId);
	}
	getNearestRoadworks(assetId: string): Observable<Roadwork[]> {
		throw new Error("Method not implemented." + assetId);
	}
	getRoadworks(): Observable<Roadwork[]> {
		throw new Error("Method not implemented.");
	}
	getNearDigitalEquipmentsNotBelongingToOtherRoadworks(lat: number, lon: number, roadworkId: string): Observable<DigitalEquipment[]> {
		throw new Error("Method not implemented." + lat + lon + roadworkId);
	}

	getAllDigitalEquipments(): Observable<DigitalEquipment[]> {
		throw new Error("Method not implemented.");
	}
	getDigitalEquipment(assetId: string): Observable<DigitalEquipment> {
		throw new Error("Method not implemented." + assetId);
	}
	getDigitalRoadwork(roadworkId: string): Observable<RoadworkSegmentAssignment[]> {
		throw new Error("Method not implemented." + roadworkId);
	}

	getPurviews(): Observable<Purview[]> {
		throw new Error("Method not implemented.");
	}

	getRoads(): Observable<RoadDto[]> {
		throw new Error("Method not implemented.");
	}
	getRoadworkSections(roadworkId: string): Observable<RoadworkSection[]> {
		throw new Error("Method not implemented." +roadworkId);
	}
	putDigitalRoadworkUpdate(roadworkSegmentAssignment: DigitalRoadworkDto[]): Observable<unknown> {
		throw new Error("Method not implemented." +roadworkSegmentAssignment);
	}
	postDigitalRoadworkDismantle(roadworkId: string): Observable<unknown> {
		throw new Error("Method not implemented." + roadworkId);
	}
	finishDigitalRoadwork(roadworkId: string): Observable<unknown> {
		throw new Error("Method not implemented." + roadworkId);
	}

	startDigitalRoadwork(roadworkSegmentAssignment: DigitalRoadworkDto[]): Observable<unknown> {
		throw new Error("Method not implemented." + roadworkSegmentAssignment);
	}
	setDigitalRoadworkToUnassignable(roadworkId: string): Observable<unknown> {
		throw new Error("Method not implemented." + roadworkId);
	}
}
